import { defineMessages } from 'react-intl';

export default defineMessages({
    faDetailsOptionPlaceholder: {
        id: 'fnol.fa.views.details.Option',
        defaultMessage: '-- Option --'
    },
    faDetailsClassCodePlaceholder: {
        id: 'fnol.fa.views.details.Select Class Code',
        defaultMessage: '-- Select Class Code --'
    },
    faDetailsRoofCoveringPlaceholder: {
        id: 'fnol.fa.views.details.Select Roof Covering Materials',
        defaultMessage: '-- Select Roof Covering Materials --'
    },
    faDetailsExteriorWallPlaceholder: {
        id: 'fnol.fa.views.details.Select Exterior Wall Material',
        defaultMessage: '-- Select Exterior Wall Material --'
    },
    fapDetailsOccupancyPlaceholder: {
        id: 'fnol.fa.views.details.Select Type of Occupancy',
        defaultMessage: '-- Select Type of Occupancy --'
    },
    faDetailsLossAreaPlaceholder: {
        id: 'fnol.fa.views.details.Select Loss Area',
        defaultMessage: '-- Select Loss Area --'
    }
});
